module.exports = __webpack_public_path__ + "img/Gorb baron 1.7c999eca.webp";